import React, { useEffect, useState } from 'react';
import { fetchRecentPurchases, timeAgoId, type RecentPurchase } from './fetch';

interface Props {
    formId?: string | null;
    active?: boolean;
    initialDelayMs?: number;
    displayMs?: number;
    intervalMs?: number;
}

const RealSocialProofToast: React.FC<Props> = ({ formId, active = true, initialDelayMs = 3000, displayMs = 4000, intervalMs = 8000 }) => {
    const [rows, setRows] = useState<RecentPurchase[]>([]);
    const [idx, setIdx] = useState(0);
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (!active || !formId) return;
        let mounted = true;
        void fetchRecentPurchases(formId).then((r) => { if (mounted) setRows(r); });
        return () => { mounted = false; };
    }, [active, formId]);

    useEffect(() => {
        if (!active || rows.length < 3) return;
        if (typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
        let hide: ReturnType<typeof setTimeout> | undefined;
        const first = setTimeout(() => {
            setIdx(Math.floor(Math.random() * rows.length));
            setShow(true);
            hide = setTimeout(() => setShow(false), displayMs);
        }, initialDelayMs);
        const timer = setInterval(() => {
            setIdx(Math.floor(Math.random() * rows.length));
            setShow(true);
            if (hide) clearTimeout(hide);
            hide = setTimeout(() => setShow(false), displayMs);
        }, intervalMs);
        return () => { clearTimeout(first); clearInterval(timer); if (hide) clearTimeout(hide); };
    }, [active, rows, initialDelayMs, displayMs, intervalMs]);

    if (!active || !formId || rows.length < 3 || !show) return null;
    const cur = rows[idx % rows.length];
    if (!cur) return null;

    return (
        <div className="fixed bottom-20 left-4 z-40">
            <div className="card-soft p-4 max-w-xs border-l-4 border-emerald-500">
                <p className="text-sm"><span className="font-bold">{cur.masked_name}</span>{` dari ${cur.city_short}`}</p>
                <p className="text-xs text-muted-foreground">{`Telah memesan produk ini · ${timeAgoId(cur.minutes_ago)}`}</p>
            </div>
        </div>
    );
};

export default RealSocialProofToast;
